
























// @ is an alias to /src
// import * as $ from "jQuery";
import unitList from "@/components/UnitList.vue";
import unitData from "@/components/UnitView.vue";
import optionTabs from "@/components/OptionTabs.vue";

export default {
  props: {
    source: String,
  },
  components: {
    "unit-list": unitList,
    "option-tabs": optionTabs,
    "unit-data": unitData,
  },
  data() {
    return {
      // imagePath: "/images",
      imagePath: "images",
      optImagePath: "",
      optionData: {},
      optionNames: ["OPT_2", "OPT_2_OPTIMIZED", "OPT_3_OPTIMIZED"],
      currentUnit: "TA_1",
      unitData: {
        sitePlanUrl: null,
        score: null,
        total: null,
        elevUrl: null,
        worstUrl: null,
        bestUrl: null,
      },
      unitList: {
        setUnit: this.setImages,
        optionSet: null,
      },
      drawer: null,
    };
  },

  watch: {},

  methods: {
    // router,
    setOptions: function(option: string) {
      console.log("SET OPTIONS: " + option);
      // console.log(this.items[item]);
      this.unitList.optionSet = this.optionData[option];

      this.optImagePath =
        this.imagePath + "/" + option + "/";
      console.log("IMAGEPATH", this.optImagePath);

      this.totalScore(option);
      this.setImages(this.currentUnit);
    },

    setImages: function(unit: string) {
      console.log("UNIT in SETIMAGES FUNC:" + this.optImagePath + unit);
      this.currentUnit = unit;
      const imageLoc = this.unitList.optionSet[unit];
      this.unitData.elevUrl = this.optImagePath + imageLoc.ANALYSIS_ELEVATION;
      this.unitData.bestUrl = this.optImagePath + imageLoc.WINDOW_VIEW_BEST;
      this.unitData.worstUrl = this.optImagePath + imageLoc.WINDOW_VIEW_WORST;
      this.unitData.sitePlanUrl = this.optImagePath + imageLoc.PLAN_VIEW;
      this.unitData.score = imageLoc.SCORE;
    },

    totalScore: function() {
      const itemCount: number = Object.values(this.unitList.optionSet).length;
      const total: any = Object.values(this.unitList.optionSet)
        .map(function(unit: any) {
          return Object.values(unit)[4];
        })
        .reduce(function(acc: any, score: any) {
          return acc + score;
        });

      this.unitData.total = Math.round((total / itemCount) * 100) / 100;

      console.log(this.unitList);
    },
  },

  created() {
    // Asynchronously call $.getJSON multiple times
    // and return one object
    let jsonData = "";
    for (const option of this.optionNames) {
      jsonData = require("../../src/assets/js/" + option + ".json");
      this.optionData = Object.assign(this.optionData, jsonData);
    }
    console.log("LOADED DATA");
    console.log(this.optionData);
    this.$nextTick(function() {
      this.setOptions("OPT_2");
    });
    //console.log(this.optionData);

    // wait a tick
    // this.$nextTick(function() {
    //   // Call initializing functions
    //   // now that EVERYTHING IS LOADED
    //   this.setOptions("OPT_1");
    // });

    // fetch("./OPT_1.json")
    //   .then((opt1) => opt1.json())
    //   .then((opt1data) => {
    //     return fetch("./OPT_2.json")
    //       .then((opt2) => opt2.json())
    //       .then((opt2data) => {
    //         return fetch("./OPT_3.json")
    //           .then((opt3) => opt3.json())
    //           .then((opt3data) => {
    //             this.optionData = Object.assign(opt1data, opt2data, opt3data);

    //             // wait a tick
    //             this.$nextTick(function() {
    //               // Call initializing functions
    //               // now that EVERYTHING IS LOADED
    //               this.setOptions("OPT_1");
    //             });
    //           });
    //       });
    //   });
    this.$vuetify.theme.light = true;
  },
};
